import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/Home"),
    children: [
      {
        path: "",
        redirect: { name: "discover" }
      },
      {
        path: "discover",
        name: "discover",
        meta: { showTab: true, pageName: "Book City" },
        component: () => import("@/views/discover/NvDiscover.vue")
      },
      {
        path: "lib",
        name: "lib",
        meta: { showTab: true, pageName: "BookShelf Add" },
        component: () => import("@/views/shelf/NvShelf.vue")
      },
      {
        path: "content",
        name: "content",
        component: () => import("@/views/book/NvBookContent.vue")
      },
      {
        path: "history",
        name: "history",
        meta: { pageName: "History" },
        component: () => import("@/views/shelf/NvReadHistory.vue")
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;
